(function(){
  function norm(value){return String(value||'').toLowerCase().trim().replace(/\s+/g,' ');}
  function cleanSearch(value){return norm(value).replace(/\b(?:finance|financial)\s+(?:course|courses|bundle|bundles)\b/g,' ').replace(/\s+/g,' ').trim();}
  function activeQuery(){try{return norm(new URLSearchParams(window.location.search).get('q')||'');}catch(e){return '';}}
  function run(){
    var q=activeQuery();
    document.querySelectorAll('[data-search]').forEach(function(card){
      var cleaned=cleanSearch(card.getAttribute('data-search')||'');
      card.setAttribute('data-search', cleaned);
      if(card.dataset) card.dataset.search=cleaned;
    });
    if(q==='finance' || q==='financial'){
      document.querySelectorAll('[data-course-card], [data-catalog-card]').forEach(function(card){
        var hay=cleanSearch((card.getAttribute('data-search')||'')+' '+(card.getAttribute('data-title')||''));
        if(hay.indexOf(q)===-1){card.classList.add('is-hidden');}
      });
    }
    document.querySelectorAll('[data-wsm-search-input-main], [data-wsm-search-input-top], [data-wsm-catalog-keyword]').forEach(function(input){
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
  setTimeout(run,150);
  setTimeout(run,700);
})();
